module.exports = __webpack_public_path__ + "static/media/slide-4.8a21e8b7.jpg";